// Extend Window to include the Matomo analytics queue
declare global {
    interface Window {
        _paq: unknown[][];
    }
}

interface AnalyticsEvent {
    category: string;
    action: string;
    name: string;
    value: string | number;
}

const AnalyticsStore = {
    namespaced: true,
    state: {},
    actions: {
        // eslint-disable-next-line no-empty-pattern
        pushEvent({}: Record<string, never>, { event }: { event: AnalyticsEvent }): void {
            window._paq.push(['trackEvent', event.category, event.action, event.name, event.value]);
        },
    },
};

export default AnalyticsStore;
